<template>
  <div class="container">
    <p>{{ tips }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tips: "暂不支持显示，请前往擎科生物APP处理",
    };
  },
  created() {
    // const userAgentInfo = navigator.userAgent;
    // //IOS端
    // if (/iPhone|iPad|iPod/i.test(userAgentInfo)) {
    //   window.location.href = "https://web-demo.tsingke.com.cn/apple-app-site-association";
    // }
    // //安卓端
    // if (/Android/.test(userAgentInfo)) {
    //   window.location.href = "weixin://dl/scan";
    // }
    // //PC端
    // if (/Windows|Macintosh/.test(userAgentInfo)) {
    //   this.tips = "电脑端暂不支持显示，请前往擎科生物APP处理";
    // }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex; /* 设置容器为flex布局 */
  justify-content: center; /* 水平居中对齐 */
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/messagePushTip/index.vue